'use strict';

define('vb/action/builtin/loadLayoutResourceAction',['vb/action/action',
  'vb/extensions/dynamic/private/types/abstractMetadataProviderDescriptor'],
(Action, AbstractMetadataProviderDescriptor) => {
  /* eslint-disable max-len */
  /** @typedef {import('vb/action/action').Outcome} Outcome */
  /** @typedef {import('vb/extensions/dynamic/private/types/dynamicLayoutMetadataProviderDescriptor').default} DynamicLayoutMetadataProviderDescriptor */
  /** @typedef {import('vb/extensions/dynamic/private/types/bridges/helperMetadataProviderFactoryBridge').default} HelperMetadataProviderFactoryBridge */
  /* eslint-enable max-len */

  /**
   * Loads a layout resource.
   * @extends Action
   * @category Action
   */
  class LoadLayoutResourceAction extends Action {
    /**
     * Loads a layout resource.
     *
     * @async
     * @param {Object} parameters - The parameters for the action.
     * @param {DynamicLayoutMetadataProviderDescriptor} parameters.metadataDescriptor - The metadata descriptor to load
     * the layout resource from.
     * @param {string} parameters.fileName - The file name of the resource to load. Only '.json' and '.html' file
     * extensions are supported.
     * @returns {Promise<Outcome>} The outcome of the action, either a success with the exported layout or
     * a failure with an error message.
     */
    // eslint-disable-next-line class-methods-use-this
    async perform(parameters) {
      const {
        metadataDescriptor,
        fileName,
      } = parameters;

      try {
        if (!(metadataDescriptor instanceof AbstractMetadataProviderDescriptor)) {
          throw new Error('A layout resource can only be loaded from a MetadataProviderDescriptor.');
        }

        const helperBridge = /** @type {HelperMetadataProviderFactoryBridge} */ (metadataDescriptor.bridge);
        const exportedLayout = helperBridge.helper.getLayoutResource(fileName);
        return Action.createSuccessOutcome(exportedLayout);
      } catch (error) {
        const message = error instanceof Error ? error.message : String(error);
        return Action.createFailureOutcome(message, error);
      }
    }
  }

  return LoadLayoutResourceAction;
});

